var _rect, _rect2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReporthead(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 738,
    height: 128,
    viewBox: "0 0 738 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 738,
    height: 553.5,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9410_137935",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 738,
    height: 554
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 738,
    height: 553.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9410_137935)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 738,
    height: 553.5,
    fill: "#B02222"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 369,
    width: 92.25,
    height: 92.25,
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.75,
    width: 92.25,
    height: 92.25,
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.75,
    y: 92.25,
    width: 92.25,
    height: 92.25,
    fill: "#C93636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.75 46.125C276.75 20.6509 297.401 0 322.875 0C348.349 0 369 20.6509 369 46.125V92.25H276.75V46.125Z",
    fill: "#C93636"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M553.5 138.375C553.5 112.901 574.151 92.25 599.625 92.25C625.099 92.25 645.75 112.901 645.75 138.375V184.5H553.5V138.375Z",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369 138.375C369 112.901 389.651 92.25 415.125 92.25C440.599 92.25 461.25 112.901 461.25 138.375V184.5H369V138.375Z",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 138.375C184.5 112.901 205.151 92.25 230.625 92.25C256.099 92.25 276.75 112.901 276.75 138.375V184.5H185.05C184.746 184.5 184.5 184.254 184.5 183.95V138.375Z",
    fill: "#EB6161"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.875,
    y: -46.125,
    width: 92.25,
    height: 92.25,
    rx: 46.125,
    fill: "#C93636"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M461.25 92.25H553.5C553.5 117.724 532.849 138.375 507.375 138.375C481.901 138.375 461.25 117.724 461.25 92.25Z",
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369 -46.125C369 -20.6509 348.349 0 322.875 0C322.875 -25.4741 343.526 -46.125 369 -46.125ZM276.75 46.125C276.75 20.6509 297.401 0 322.875 0C322.875 25.4741 302.224 46.125 276.75 46.125ZM322.875 0C297.401 0 276.75 -20.6509 276.75 -46.125C302.224 -46.125 322.875 -25.4741 322.875 0ZM322.875 0C348.349 0 369 20.6509 369 46.125C343.526 46.125 322.875 25.4741 322.875 0Z",
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 553.5,
    width: 92.25,
    height: 92.25,
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 92.25,
    width: 92.25,
    height: 92.25,
    fill: "#C93636"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 461.25,
    width: 92.25,
    height: 92.25,
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 92.25,
    y: 92.25,
    width: 92.25,
    height: 92.25,
    fill: "#EB6161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.5 92.25H92.25C92.25 66.7759 112.901 46.125 138.375 46.125C163.849 46.125 184.5 66.7759 184.5 92.25Z",
    fill: "#EB6161"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M184.5 0C184.5 25.4741 163.849 46.125 138.375 46.125C138.375 20.6509 159.026 0 184.5 0Z",
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.25 92.25C92.25 66.7759 112.901 46.125 138.375 46.125C138.375 71.5991 117.724 92.25 92.25 92.25Z",
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M161.438 178.307C147.651 170.332 138.375 155.425 138.375 138.353C138.375 121.28 147.651 106.374 161.438 98.3984C175.224 106.374 184.5 121.28 184.5 138.353C184.5 155.425 175.224 170.332 161.438 178.307Z",
    fill: "#F8E5A5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M369 92.25C369 117.724 348.349 138.375 322.875 138.375C322.875 112.901 343.526 92.25 369 92.25Z",
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.25 92.25C92.25 117.724 71.5991 138.375 46.125 138.375C46.125 112.901 66.7759 92.25 92.25 92.25Z",
    fill: "#A73636"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 92.25,
    height: 92.25,
    rx: 46.125,
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M547.307 115.312C539.332 129.099 524.425 138.375 507.353 138.375C490.28 138.375 475.374 129.099 467.398 115.312C475.374 101.526 490.28 92.25 507.353 92.25C524.425 92.25 539.332 101.526 547.307 115.312Z",
    fill: "#C93636"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.062,
    y: 115.312,
    width: 46.125,
    height: 46.125,
    rx: 23.0625,
    fill: "#A73636"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M645.75 46.125C645.75 71.5991 625.099 92.25 599.625 92.25C599.625 66.7759 620.276 46.125 645.75 46.125ZM553.5 138.375C553.5 112.901 574.151 92.25 599.625 92.25C599.625 117.724 578.974 138.375 553.5 138.375ZM599.625 92.25C574.151 92.25 553.5 71.5991 553.5 46.125C578.974 46.125 599.625 66.7759 599.625 92.25ZM599.625 92.25C625.099 92.25 645.75 112.901 645.75 138.375C620.276 138.375 599.625 117.724 599.625 92.25Z",
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.5 0H276.75V46.125C276.75 71.5991 256.099 92.25 230.625 92.25C205.151 92.25 184.5 71.5991 184.5 46.125V0Z",
    fill: "#DB3333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M230.625 46.125C230.625 20.6509 251.276 0 276.75 0C276.75 25.4741 256.099 46.125 230.625 46.125Z",
    fill: "#FE5E33"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M645.75 46.125C645.75 20.6509 666.401 0 691.875 0H738V92.25H691.875C666.401 92.25 645.75 71.5991 645.75 46.125Z",
    fill: "#F77C74"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M731.807 115.312C723.832 129.099 708.925 138.375 691.853 138.375C674.78 138.375 659.874 129.099 651.898 115.312C659.874 101.526 674.78 92.25 691.853 92.25C708.925 92.25 723.832 101.526 731.807 115.312Z",
    fill: "#A73636"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.25 -46.125C92.25 -20.6509 71.5991 0 46.125 0C46.125 -25.4741 66.7759 -46.125 92.25 -46.125ZM92.25 46.125C66.7759 46.125 46.125 25.4741 46.125 0C71.5991 0 92.25 20.6509 92.25 46.125ZM46.125 0C20.6509 0 0 -20.6509 0 -46.125C25.4741 -46.125 46.125 -25.4741 46.125 0ZM46.125 0C46.125 25.4741 25.4741 46.125 0 46.125C0 20.6509 20.6509 0 46.125 0Z",
    fill: "#F77C74"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReporthead);
export default __webpack_public_path__ + "static/media/reporthead.9dc659d447c6933fd0a065925502ae0c.svg";
export { ForwardRef as ReactComponent };